/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function () {
  // ADA fix for carousel
	jQuery('.kt-blocks-carousel-init').attr('aria-label', 'Carousel');
  
  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
    function () {
      if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
        jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
      } else {
        jQuery(this).wrap("<div class='responsive-embed'/>");
      }
  });

    // Block: "Read More" Toggle Buttons
	var instance = [ '1', '2', '3', '4' ];
	jQuery.each( instance, function( i, val ) {
		jQuery('.toggle-' + val).click(function(e){
			e.preventDefault();
			jQuery('.showHide-' + val).slideToggle();
			jQuery(this).text( jQuery(this).text() == 'Read More' ? "Read Less" : "Read More");
		});
	});

  //DYLAN --- add data-toggle property to make book an inspection button work
  console.log('test grn button');
  jQuery('.lp-grn-button').attr('data-toggle', 'getAnInspectionLP');
  // jQuery("a:contains('Book An Inspection')").attr('data-toggle', 'getAnInspection');
  // jQuery("a:contains('Get An Inspection')").attr('data-toggle', 'getAnInspection');

  var existingTitles = document.getElementsByTagName('title');
  if (existingTitles.length > 1) {
      existingTitles[1].parentNode.removeChild(existingTitles[1]);
  }

  var existingDescriptions = document.querySelectorAll('meta[name="description"]');
  if (existingDescriptions.length > 1) {
      existingDescriptions.forEach(function(description, index) {
          if (index > 0) {
              description.parentNode.removeChild(description);
          }
      });
  }

  //make sure book an inspection buttons have correct green
  // jQuery(".kt-btn-wrap a:contains('Book An Inspection')").css('background-color', '#7ac143');
  jQuery('.ptop-default-button').css('background', '#7ac143 !important');


  // OLD JAVASCRIPT

  jQuery('[role="menu-item"], [role="menuitem"]').on(
    'focus.aria  mouseenter.aria',
    '[aria-haspopup="true"]',
    function (ev) {
      jQuery(ev.currentTarget).attr('aria-expanded', true);
    }
  );

  // Properly update the ARIA states on blur (keyboard) and mouse out events
  jQuery('[role="menu-item"], [role="menuitem"]').on(
    'blur.aria  mouseleave.aria',
    '[aria-haspopup="true"]',
    function (ev) {
      jQuery(ev.currentTarget).attr('aria-expanded', false);
    }
  );
  jQuery('[role="menubar"], [role="menuitem"]').on(
    'focus.aria  mouseenter.aria',
    function (ev) {
      jQuery(ev.currentTarget).attr('aria-expanded', true);
    }
  );

  // Properly update the ARIA states on blur (keyboard) and mouse out events
  jQuery('[role="menubar"], [role="menuitem"]').on(
    'blur.aria  mouseleave.aria',
    function (ev) {
      jQuery(ev.currentTarget).attr('aria-expanded', false);
    }
  );
  // modal for button
  //data-toggle="exampleModal8"

  jQuery('.mobile-menu').attr('tabindex', '-1');

  jQuery('.ui-datepicker-month').attr('aria-label', 'month dropdown selector');
  jQuery('.ui-datepicker-year').attr('aria-label', 'year dropdown selector');
  const tabs = document.querySelectorAll('[role="tab"]').children;
  const tabList = document.querySelector('[role="tablist"]');
  const tabpanel = document.querySelector('[role="tabpanel"]');
  const menuitem = document.querySelector('[role="menubar"]').children;

  jQuery('nav#navTopBar > ul', 'nav#mobile-menu > ul').attr('role', 'menubar');
  jQuery('nav#navTopBar > ul > li').attr('role', 'none');
  jQuery('nav#navTopBar > ul > li.menu-item-has-children').removeAttr(
    'aria-haspopup aria-expanded aria-label'
  );
  jQuery('nav#navTopBar > ul > li > a').attr('role', 'menuitem');

  jQuery('nav#mobile-menu ul.offcanvas-menu').removeAttr('role', 'menu');
  jQuery('nav#mobile-menu ul.offcanvas-menu').attr('role', 'tablist');
  jQuery('nav#mobile-menu > ul > li').attr('role', 'none');
  jQuery('nav#mobile-menu > ul > li.menu-item-has-children').removeAttr(
    'aria-haspopup aria-expanded aria-label aria-controls'
  );

  // New JS

  var links = document.querySelectorAll('a.button');
  console.log(links);
  for (var i = 0, len = links.length; i < len; i++) {
    links[i].addEventListener(
      'click',
      function (e) {
        var targetEl = e.target;
        var inkEl = targetEl.querySelector('.ink');

        if (inkEl) {
          inkEl.classList.remove('animate');
        } else {
          inkEl = document.createElement('span');
          inkEl.classList.add('ink');
          inkEl.style.width = inkEl.style.height =
            Math.max(targetEl.offsetWidth, targetEl.offsetHeight) + 'px';
          targetEl.appendChild(inkEl);
        }

        inkEl.style.left = e.offsetX - inkEl.offsetWidth / 2 + 'px';
        inkEl.style.top = e.offsetY - inkEl.offsetHeight / 2 + 'px';
        inkEl.classList.add('animate');
      },
      false
    );
  }

  jQuery(function () {
    jQuery(document).on('show.zf.dropdownmenu', function (ev, jQueryel) {
      console.log('open');
      // jQuery('li.additional-services ul.is-dropdown-submenu').removeClass(
      //   'js-dropdown-active'
      // );
    });

    // jQuery('li.additional-services').click(function(e) {
    //   jQuery(
    //     'li.additional-services, li.additional-services ul.is-dropdown-submenu'
    //   ).toggleClass('changed');
    //   document
    //     .querySelector(`li.home-inspections ul.is-dropdown-submenu`)
    //     .classList.toggle('menu__container_additional');
    // });
  });

  // Correct way to console log menu interactions
  /*
  jQuery(document).on('show.zf.dropdownmenu', function(ev, jQueryel) {
      console.log('open');
  });
  */

  //ADA Updates
  //jQuery('.menu-item').attr('aria-selected', 'true');
  jQuery('.submenu').removeAttr('role');
  jQuery('.menu-item').attr('aria-selected', 'true');
  jQuery('.menu-item').attr('aria-expanded', 'true');
  jQuery('.menu-item').removeAttr('role');
  // Hotspot ADA Fixes
  jQuery('.pins_image').attr('alt', 'info icon');
  jQuery('.images_wrap > img').attr('alt', 'house');
  jQuery('#main-nav .menu-item').attr('role', 'menuitem');
  jQuery('.kt-video-svg-icon svg').prepend('<title>Play Video</title>');
  jQuery('#radon-accordion').attr('role', 'none');
  jQuery('#radon-accordion .accordion-item > a').attr('role', 'button');
  jQuery('.ptpfloorplan-modal-btn button').attr('aria-label', 'Click to expand');

  //Booking Tip
  // jQuery("#close-tip").click(function () {
  //   jQuery("#book-tip").hide();
  //   jQuery('#inspection-form-spacer').hide();
  //   jQuery("#topModalSection").css('margin-top', '0');
  //   jQuery("#close-inspection-form").css('margin-top', '0');
  // });



  // END DEFAULT SCRIPT

  //Header Banner with close option 
	jQuery(".close-image").click(function(){
		jQuery(".notification-bar").hide();
	});

  let currentURL= window.location.href;

  if ( currentURL === 'https://pillartopost.online/' || currentURL === 'https://pillartopost.online/home-buyer/' || currentURL === 'https://pillartopost.online/real-estate-agents/' || currentURL === 'https://pillartopost.com/' || currentURL === 'https://pillartopost.com/home-buyer/' || currentURL === 'https://pillartopost.com/real-estate-agents/'){
    jQuery(".notification-bar").show();
  }


  var newElement1 = document.querySelector(`div#apply-now`);
  if (typeof newElement1 != 'undefined' && newElement1 != null) {
    // jQuery('.get-an-inspection').attr('data-toggle', 'getAnInspection');
  
    var d2 = document.getElementById('gform_10');
    d2.insertAdjacentHTML(
      'afterbegin',
      `<div id="stepsSection">
      <h5 class="getAnInspectionHeader">Become part of the team</h5>
      <p class="small start-inspection">Fill out the fields below to apply.</p>
    </<div>`
    );
  
    console.log(d2);
  
    var insertElement1 = document
      .querySelector(`div#gf_page_steps_10 .gf_step_clear`)
      .insertAdjacentHTML(
        'beforebegin',
        `<div id="oi_gf_checkmark" class="gf_step oi_gf_checkcontainer"><span class="gf_step_number gf_check"></span><span class="gf_step_label">Completed Form</span></div>`
      );
  
    console.log(insertElement1);
  }

  // For static booking page, show form
  jQuery('#on-page-form > #gform_wrapper_6').show();
});

// ADA fixes
jQuery(window).bind("load", function () {
  // forces iframe manipulation
  jQuery('iframe[src*="https://bid.g.doubleclick.net"]').attr('title', 'tracking pixel');
  jQuery('#g-recaptcha-response-2').attr('aria-label', 'input field for recaptcha');
  jQuery('#g-recaptcha-response-1').attr('aria-label', 'input field for recaptcha');
  jQuery('#g-recaptcha-response').attr('aria-label', 'input field for recaptcha');

  //Booking Tip
  jQuery("#close-tip").click(function () {
    jQuery("#book-tip").hide();
    jQuery('#inspection-form-spacer').hide();
    jQuery("#topModalSection").css('margin-top', '0');
    jQuery("#close-inspection-form").css('margin-top', '0');
  });
});

// jQuery(window).resize(function () {
//   let iframeHeight = jQuery(".iframe-ptp360").height();
//   let iframeWidth = jQuery(".iframe-ptp360").width();
//   let iframeRatio = (iframeWidth / iframeHeight);
//   jQuery('.container-ptp360').css('padding-top', iframeRatio + "%")
// });
// Custom GF Modal - LOCAL
// var newElement =  document.querySelector( `div#gravityWrapper` );
// if (typeof(newElement) != 'undefined' && newElement != null){

// 	jQuery('.get-an-inspection').attr('data-toggle', 'getAnInspection');

// 	var d1 = document.getElementById('gform_2');
// 	d1.insertAdjacentHTML('afterbegin',`<div id="stepsSection">
// 		<h5 class="getAnInspectionHeader">Home Inspection Request</h5>
// 		<p class="small start-inspection">Start your inspection today.</p>
// 	</<div>`);

// 	console.log(d1);

// 	var insertElement =  document.querySelector( `div#gf_page_steps_2 .gf_step_clear` ).insertAdjacentHTML('beforebegin',`<div id="oi_gf_checkmark" class="gf_step oi_gf_checkcontainer"><span class="gf_step_number gf_check"></span><span class="gf_step_label">Completed Form</span></div>`);

// 	console.log(insertElement);

// }

/**
 *
 * Sometimes we need to comment this our because our
 * Gravity forms will not match
 *
 */

var newElement = document.querySelector(`div#gravityWrapper`);
if (typeof newElement != 'undefined' && newElement != null) {
  jQuery('.get-an-inspection').attr('data-toggle', 'getAnInspection');
  jQuery('.get-an-inspectionLP').attr('data-toggle', 'getAnInspectionLP');

  var d1 = document.getElementById('gform_6');
  d1.insertAdjacentHTML(
    'afterbegin',
    `<div id="stepsSection">
		<h5 class="getAnInspectionHeader">Home Inspection Request</h5>
		<p class="small start-inspection">Start your inspection today.</p>
	</<div>`
  );

  console.log(d1);
  
  var insertElement = document.querySelector(`div#gf_page_steps_6 .gf_step_clear`)
    // check if the element exists
    if (insertElement != null) {
    insertElement.insertAdjacentHTML(
      'beforebegin',
      `<div id="oi_gf_checkmark" class="gf_step oi_gf_checkcontainer"><span class="gf_step_number gf_check"></span><span class="gf_step_label">Completed Form</span></div>`
    );
    } else {
      console.log('element does not exist');
    }

  console.log(insertElement);
}

// For RTB version of Book An Inspection form
var RFIElement = document.querySelector(`form#gform_15`);
if (typeof RFIElement != 'undefined' && RFIElement != null) {

  var d3 = document.getElementById('gform_15');
  d3.insertAdjacentHTML(
    'afterbegin',
    `<div id="stepsSection">
		<h5 class="getAnInspectionHeader">Home Inspection Request</h5>
		<p class="small start-inspection">Start your inspection today.</p>
	</<div>`
  );

  console.log(d3);
  
  var insertElement = document.querySelector(`div#gf_page_steps_15 .gf_step_clear`)
    // check if the element exists
    if (insertElement != null) {
    insertElement.insertAdjacentHTML(
      'beforebegin',
      `<div id="oi_gf_checkmark" class="gf_step oi_gf_checkcontainer"><span class="gf_step_number gf_check"></span><span class="gf_step_label">Completed Form</span></div>`
    );
    } else {
      console.log('element does not exist');
    }

  console.log(insertElement);
}

/**
 *
 * Resume
 *
 */

var newElement = document.querySelector(`div#homeBuyerLink`);
if (typeof newElement != 'undefined' && newElement != null) {
  let homebuyerlink = document.getElementById('homeBuyerLink');

  homebuyerlink.onclick = homeChange;

  function homeChange(e) {
    window.location = 'https://pillartopost.com/home-buyer/';
  }
}
var newElement = document.querySelector(`div#realEstateLink`);
if (typeof newElement != 'undefined' && newElement != null) {
  let realEstateLink = document.getElementById('realEstateLink');

  realEstateLink.onclick = realChange;

  function realChange(e) {
    window.location = 'https://pillartopost.com/real-estate-agents/';
  }
}

// ONLY FOR THE IMAGE ICONS
var element = document.querySelector(`div.wrap_svl_center`);
if (typeof element != 'undefined' && element != null) {
  var removeActive = document.getElementsByClassName('drag_element');
  for (var i = 0; i < removeActive.length; i++) {
    (function (index) {
      removeActive[index].addEventListener('click', function () {
        var remove = document.getElementsByClassName('serviceContainer');
        for (var i = 0; i < remove.length; i++) {
          remove[i].classList.remove('active');
          console.log(remove[i].className);
        }
      });
    })(i);
  }
  //Exterior
  document.getElementById('pin1').addEventListener('click', function () {
    var element = document.getElementsByClassName('roofsAttics');
    for (var x = 0; x < element.length; x++) {
      element[x].classList.add('active');
      console.log(element[x].className);
    }
  });
  document.getElementById('pin2').addEventListener('click', function () {
    var element = document.getElementsByClassName('gutterDrainage');
    for (var x = 0; x < element.length; x++) {
      element[x].classList.add('active');
      console.log(element[x].className);
    }
  });
  document.getElementById('pin3').addEventListener('click', function () {
    var element = document.getElementsByClassName('porchDeck');
    for (var x = 0; x < element.length; x++) {
      element[x].classList.add('active');
      console.log(element[x].className);
    }
  });
  document.getElementById('pin4').addEventListener('click', function () {
    var element = document.getElementsByClassName('structuralFoundation');
    for (var x = 0; x < element.length; x++) {
      element[x].classList.add('active');
      console.log(element[x].className);
    }
  });
  // Interior **************************************
  document.getElementById('pin5').addEventListener('click', function () {
    var element = document.getElementsByClassName('electrical');
    for (var x = 0; x < element.length; x++) {
      element[x].classList.add('active');
      console.log(element[x].className);
    }
  });
  document.getElementById('pin6').addEventListener('click', function () {
    var element = document.getElementsByClassName('wallsFloors');
    for (var x = 0; x < element.length; x++) {
      element[x].classList.add('active');
      console.log(element[x].className);
    }
  });
  document.getElementById('pin7').addEventListener('click', function () {
    var element = document.getElementsByClassName('waterHeaters');
    for (var x = 0; x < element.length; x++) {
      element[x].classList.add('active');
      console.log(element[x].className);
    }
  });
  document.getElementById('pin8').addEventListener('click', function () {
    var element = document.getElementsByClassName('plumbing');
    for (var x = 0; x < element.length; x++) {
      element[x].classList.add('active');
      console.log(element[x].className);
    }
  });
}
  // BEGIN STICKY
  var element = document.querySelector(`div#stickThis`);
  if (typeof element != 'undefined' && element != null) {
    window.onscroll = function () {
      stickFunction();
    };

    // Get the header
    var header = document.getElementById('stickThis');

    // Get the offset position of the navbar
    var fixstop = header.offsetTop;

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function stickFunction() {
      if (window.scrollY > 687) {
        header.classList.add('fix-stop');
      } else {
        header.classList.remove('fix-stop');
      }
    }
  }

var videoElement = document.querySelector(`div#videoHero`);
if (typeof videoElement != 'undefined' && videoElement != null) {
  document
    .getElementsByClassName('video-start')[0]
    .setAttribute('id', 'videoButton');

  document
    .getElementsByClassName('kb-blocks-bg-video')[0]
    .setAttribute('id', 'homeBuyerVideo');

  document
    .getElementsByClassName('kt-modal-overlay')[0]
    .setAttribute('id', 'ktModalOverlay');

  var vid = document.getElementById('homeBuyerVideo');

  function pauseVid() {
    vid.pause();
  }

  function playVid() {
    vid.play();
  }

  document
    .getElementById('ktModalOverlay')
    .addEventListener('click', function () {
      vid.play();
    });

  document.getElementById('videoButton').addEventListener('click', function () {
    vid.pause();
  });
}

var sideElement = document.querySelector(`div.find-inspector-sticky`);
console.log(sideElement);
if (typeof sideElement != 'undefined' && sideElement != null) {
  function sticky_relocate_2() {
    // https://stackoverflow.com/questions/57525424/how-do-i-add-and-remove-class-while-scrolling-past-an-element
    var window_top = jQuery(window).scrollTop();
    var div_top = jQuery('.find-inspector-sticky').offset().top - 156;

    if (window_top > div_top) {
      jQuery('.find-inspector-sticky .kt-inside-inner-col').addClass(
        'stickyyyyy'
      );
    }
    //if window top reaches the limit removed class
    if (window_top > jQuery('#footerReadyCta').position().top - 700) {
      jQuery('.find-inspector-sticky .kt-inside-inner-col').removeClass(
        'stickyyyyy'
      );
    }
    console.log(div_top);
  }

  jQuery(window).scroll(sticky_relocate_2);

  window.onscroll = function () {
    newStickyFunction();
  };

  // Get the header
  var mainHeader = document.getElementById('mainHeader');
  console.log(mainHeader);

  // Get the offset position of the navbar
  var fixstop = mainHeader.offsetTop;
  console.log(fixstop);

  document
    .getElementsByClassName('find-inspector-sticky')[0]
    .setAttribute('id', 'stickSide');

  var sidebarStuck = document.getElementById('stickSide').children[0];
  console.log(sidebarStuck);

  var footerRelief = document.getElementById('footerReadyCta');
  console.log(footerRelief);

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function newStickyFunction() {
    if (window.scrollY > 342) {
      sidebarStuck.classList.add('set-position');
    } else {
      sidebarStuck.classList.remove('set-position');
    }
  }
}

jQuery(document).ready(function () {
  //ada 
  jQuery('#cc-window > div:nth-child(3) > a:nth-child(1)').attr('name', 'Call to action button');
//ada
jQuery('#mainHeader > div:nth-child(3) > div > div > img').attr('alt', 'close image');
jQuery('#kt-modal_979ede-f8 > button').attr('name', 'modal button');
});


// Hover slider 
const allContainers = document.querySelectorAll('.container')
const firstText = document.querySelectorAll('.a-text')
const secondText = document.querySelectorAll('.b-text')

function show() {
  firstText.forEach((ele) =>{
    ele.classList.remove('hide')
  })
  secondText.forEach((elem) =>{
    elem.classList.add('hide')
  })
}

function hide() {
  firstText.forEach((ele) =>{
    ele.classList.add('hide')
  })
  secondText.forEach((elem) =>{
    elem.classList.remove('hide')
  })
}

// jQuery('button.kt-blocks-modal-link').attr('aria-label', 'PDF Popup Modal');

